import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react'
import './login.css';
import { LoginModel } from '../models/LoginModel';
import { EmailsModel } from '../models/EmailsModel';
import { SimulatorModel } from '../models/SimulatorModel';

// import SignalRServiceModel from "../models/SignalRServiceModel";
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import { LeadMessagePopup } from '../leads/_LeadMessagePopup';
import { useSelector, useDispatch } from 'react-redux'
import { logIn } from '../app-context/user';
import { setLoadTreatmentToQueue } from '../app-context/caller';
import Otp from './_Otp';
import { set } from 'lodash';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const userLogged = useSelector((state: any) => state.user.value)
    const loginModel: LoginModel = new LoginModel();
    const emailsModel: EmailsModel = new EmailsModel();

    const [savedUser, setSavedUser] = useState<any | null>(null)
    const [userName, setUserName] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const [showPopUp, setShowPopUp] = useState<boolean>(false);
    const [inActiveUser, setInActiveUser] = useState<boolean>(false);

    // NEW:
    const [showOptModel, setShowOptModel] = useState<boolean>(false);
    const [step, setStep] = useState<"form" | "otp">("form");
    // const [pendingOtp, setPendingOtp] = useState<{ otpToken: string; nextPath: string } | null>(null);
    const [otpError, setOtpError] = useState<string | null>(null);
    const [otpLoading, setOtpLoading] = useState<boolean>(false);

    const [userData, setUserData] = useState<any>(null);

    useEffect(() => {
        const userDataStr = localStorage.getItem('loggedUser');
        if (userDataStr) {
            setSavedUser(JSON.parse(userDataStr));
            if (loginModel.isAuthTokenSaved()) {
                // console.log('init App -> found logged user')
                navigate(`/Leads`);
            }
        } else {
            sessionStorage.clear();
            localStorage.clear();
            const apiUrl = localStorage.getItem('apiUrl');
            if (!apiUrl) {
                fetchData();
            }
        }
    }, []);

    const fetchData = async () => {
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            localStorage.setItem('apiUrl', jsonData.apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
            // setData(jsonData);
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
    };

    const onUserNameChange = (event: any) => {
        setInActiveUser(false)
        setUserName(event.target.value)
    }
    const onUserPasswordChange = (event: any) => {
        setInActiveUser(false)
        setUserPassword(event.target.value)
    }
    const onLoginClick = async () => {
        // 
        setLoading(true);
        if (userName !== '' && userPassword !== '') {
            const loginData = await loginModel.loginUser(
                {
                    UserName: userName,
                    Password: userPassword
                }
            )
            if (loginData && loginData.user && loginData.user.id) {
                console.log('userLoginData-login-before otp', loginData)

                // need to delete. now i save it just for testing
                setUserData(loginData)

                if (loginData.otpForce == false) {
                    finalizeLoginAndNavigate(loginData);
                    setLoading(false);
                    return;
                }


                try {
                    if (loginModel.userSendOTPCode) {
                        let res = await loginModel.userSendOTPCode({ id: loginData.user.id, OTPOption: 0 });
                        console.log('userLoginData', res)
                    }
                } catch (e) {
                    console.error("requestOtp failed", e);
                }


                // finalizeLoginAndNavigate(loginData);
                setShowOptModel(true)
            } else {
                if (loginData.status == 1) {
                    setInActiveUser(true)
                } else {
                    console.log('login failed');

                    setShowPopUp(true)
                }
            }
        }
        setLoading(false);
    }

    const finalizeLoginAndNavigate = async (loginData: any) => {
        if (savedUser && savedUser.id) {
            if (savedUser.id !== loginData.id) {
                loginModel.clearSavedUserData();
            }
        } else {
            loginModel.clearSavedUserData();
        }
        localStorage.setItem('AuthToken', loginData.token);


        const emailSettings = await loadMailSettings();
        localStorage.setItem('emailSettings', JSON.stringify(emailSettings));

        const userMenuPermissions = await loginModel.userGetRoles();
        localStorage.setItem('loggedUser', JSON.stringify({
            email: loginData.user.email,
            name: loginData.user.name,
            id: loginData.user.id,
            role: loginData.role,
            menuPermissions: userMenuPermissions,
            agentId: loginData.agentId,
            branchName: loginData.branchName,
            extensions: loginData.extensions,
        }));

        dispatch(setLoadTreatmentToQueue({ load: true })); // Reset the flag after loading

        localStorage.setItem('isAdminUser', (loginData.role == 0) + "");
        const simulatorModel: SimulatorModel = new SimulatorModel();
        simulatorModel.getAddressesAll();


        let nextPathName = localStorage.getItem('lastPathName');
        if (!nextPathName || nextPathName == '' || nextPathName == '/' || nextPathName == '/login') {
            console.log('/Leads')
            nextPathName = '/Leads';
        }

        dispatch(logIn())
        dispatch(setLoadTreatmentToQueue({ load: false })); // Reset the flag after loading

        navigate(`${nextPathName}`);
    }


    const loadMailSettings = async () => {
        const emailSettings: any = await emailsModel.getEmailsSettings();

        emailSettings.emails.forEach(async (emailAccount: any) => {
            const folders = await emailsModel.getFolders(emailAccount.id);
            localStorage.setItem(`emailAccount_${emailAccount.id}`, JSON.stringify(folders));
        });

        return emailSettings;
    }

    const closeMessagePopup = () => {
        setShowPopUp(false)
    }


    // ===== OTP handlers =====
    const handleOtpSubmit = async (code: string) => {
        // if (!pendingOtp) return;
        try {
            setOtpLoading(true);
            setOtpError(null);
            // Exchange code + otpToken -> final loginData
            // Implement this in your LoginModel:
            // verifyOtp should return the same structure you currently get on successful login.
            // const verified = await (mockVerifyOtp_Success("pendingOtp.otpToken", code) // temp fallback
            // );

            let userLoginData = await loginModel.userCheckOTPCode({
                id: userData.user.id,
                OTP: code,
            });
            console.log('userLoginData-login-after otp', userLoginData)
            if(userLoginData && userLoginData.token){

                await finalizeLoginAndNavigate(userLoginData);
            } else {
                setOtpError("קוד שגוי. נסה שוב.");
            }

            // navigate(pendingOtp.nextPath);
        } catch (e: any) {
            console.error("verifyOtp failed", e);
            setOtpError("קוד שגוי. נסה שוב.");
        } finally {
            setOtpLoading(false);
        }
    };

    const handleOtpResend = async () => {
        // if (!pendingOtp || !loginModel.requestOtp) return;
        try {
            // await loginModel.requestOtp({ otpToken: pendingOtp.otpToken });
        } catch (e) {
            console.error("requestOtp failed", e);
        }
    };


    // ===== On Send Email Click =====

    const handleSendEmailClick = async () => {
        try {
            if (userData && loginModel.userSendOTPCode) {
                await loginModel.userSendOTPCode({ id: userData.user.id, OTPOption: 1 });
            }
        } catch (e) {
            console.error("requestOtp failed", e);
        }
    };

    return (
        <>
            <div className='login-wrapper'>
                <div className='login-form-container'>
                    <div className='login-inner'>
                        <div className='logo-row'>
                            <div className='logo'></div>
                        </div>
                        {!showOptModel &&
                            <div className='login-form-holder'>
                                <div className='login-form-row'>
                                    <div className='input-field'>
                                        <div className='label'>
                                            אימייל
                                        </div>
                                        <div className='input'>
                                            <input type='text' placeholder='' value={userName} onChange={onUserNameChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className='login-form-row'>
                                    <div className='input-field'>
                                        <div className='label'>
                                            סיסמה
                                        </div>
                                        <div className='input'>
                                            <input type='password' placeholder='' value={userPassword} onChange={onUserPasswordChange} />
                                        </div>
                                    </div>
                                </div>
                                {inActiveUser && <div className='login-form-row flex-justify-center'>
                                    <div className='error-message'>משתמש לא פעיל</div>
                                </div>}
                                <div className='login-form-row buttons-row'>
                                    <button
                                        className='login-form-btn login-btn'
                                        onClick={onLoginClick}
                                    >
                                        כניסה
                                    </button>
                                    <button className='login-form-btn act-btn flex-centered flex-justify-center'>
                                        הרשמה
                                    </button>
                                </div>
                                <div className='login-form-row forgot-password-row'>
                                    <div className='forgot-password-link'>
                                        <a href='#' onClick={() => { return false }}>
                                            שכחתי סיסמה
                                        </a>
                                    </div>
                                </div>
                            </div>
                        }
                        {showOptModel &&
                            <Otp
                                length={5}
                                loading={otpLoading}
                                error={otpError}
                                onSubmit={handleOtpSubmit}
                                onResend={handleOtpResend}
                                phoneHint={undefined}
                                countdownSeconds={240}
                                sendEmailLabel={"שלח לי קוד במייל"}
                                onSendEmail={handleSendEmailClick}

                            />
                        }
                    </div>
                </div>
                {
                    loading && (
                        <PleaseWaitLayer />
                    )
                }
                {
                    showPopUp &&
                    <LeadMessagePopup
                        ClosePopup={closeMessagePopup}
                        messageContent={'שם משתמש או סיסמא שגויים'}
                    />
                }

            </div>
        </>
    )
}

export default Login;
